// extracted by mini-css-extract-plugin
export var fadeIn = "_94-0";
export var panelInner = "_94-2";
export var panelOuter = "_94-1";